import { DialogContextProvider as DialogContextProviderCommon } from '@lovoldsystem/core.client'
import { Box } from '@mui/material'
import { useEffect } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { FeatureRoute } from 'src/components/app-feature/FeatureRoute'
import { UnAuthorizationPage } from 'src/components/common/UnAuthorizationPage'
import { CenteredSpinner } from 'src/components/Spinner'
import { AppFeatureIntegration } from 'src/constants/appFeatureIntegrations'
import { AppFeatureScope } from 'src/constants/appFeatureScope'
import { DialogContextProvider } from 'src/context/DialogContext'
import { FeatureFlagsProvider } from 'src/context/FeatureFlagsContext'
import { IdentityServerUserContextProvider } from 'src/context/IdentityServerUserContext'
import StorageMainPage from 'src/pages/storage/StorageMainPage'
import CertificateDatabaseContainer from 'src/screens/customer/certificate/CertificateDatabaseContainer'
import ProjectMainPage from 'src/screens/project/ProjectMainPage'
import { UserProfileScreen } from 'src/screens/UserProfileScreen'
import { AppRoutesRouter } from '../../app-routes'
import { UserContextProvider } from '../../context/UserContext'
import { BoatsScreen } from '../../screens/boats/BoatsScreen'
import LocalityMainPage from '../../screens/localities/LocalityMainPage'
import ServiceStationMainPage from '../../screens/serviceStations/ServiceStationMainPage'
import { closeAllDialog } from '../../show-dialog'
import Layout from '../MainLayout'
import { AdminRoutes } from './AdminRoutes'
import { CustomerAdminRoutes } from './CustomerAdminRoutes'
import { LocalitiesRoutes } from './LocalitiesRoutes'
import ProjectAdminRoutes from './ProjectAdminRoutes'
import ProjectRoutes from './ProjectRoutes'
import { ServiceStationRoutes } from './ServiceStationRoutes'
import { StorageRoutes } from './StorageRoutes'
export const MainRoutes = () => {
  const location = useLocation()

  useEffect(() => {
    closeAllDialog()
  }, [location])

  return (
    <IdentityServerUserContextProvider>
      <UserContextProvider>
        <FeatureFlagsProvider>
          <DialogContextProviderCommon>
            <DialogContextProvider>
              <Layout>
                <Routes>
                  <Route path={'/'} element={<CenteredSpinner />} />
                  <Route path={AppRoutesRouter.Profile} element={<UserProfileScreen />} />
                  <Route path={AppRoutesRouter.Localities.main} element={MainAppBarHOC(LocalityMainPage)} />
                  <Route path={AppRoutesRouter.serviceStation.main} element={MainAppBarHOC(ServiceStationMainPage)} />
                  <Route
                    path={AppRoutesRouter.Project.main}
                    element={
                      <FeatureRoute
                        integrationKey={AppFeatureIntegration.PortalMainProjectManagement}
                        accessField="hasProjectPlanningAccess"
                        scope={AppFeatureScope.Global}
                        element={MainAppBarHOC(ProjectMainPage)}
                      />
                    }
                  />
                  <Route
                    path={AppRoutesRouter.storage.main}
                    element={MainAppBarHOC(() => (
                      <StorageMainPage />
                    ))}
                  />
                  <Route path={AppRoutesRouter.UnAuth} element={<UnAuthorizationPage />} />
                  <Route path="*" element={<SubRoutes />} />
                </Routes>
              </Layout>
            </DialogContextProvider>
          </DialogContextProviderCommon>
        </FeatureFlagsProvider>
      </UserContextProvider>
    </IdentityServerUserContextProvider>
  )
}

export const MainAppBarHOC = Content => {
  return (
    <Box className="flex w-full h-full">
      <Content />
    </Box>
  )
}

const SubRoutes = () => {
  return (
    <Box className="flex w-full">
      <Routes>
        <Route path={AppRoutesRouter.Localities.basePath} element={<LocalitiesRoutes />} />
        <Route path={AppRoutesRouter.Home} element={<LocalitiesRoutes />} />
        <Route path={AppRoutesRouter.Customer.basePath} element={<CustomerAdminRoutes />} />
        <Route path={AppRoutesRouter.serviceStation.basePath} element={<ServiceStationRoutes />} />
        <Route path={AppRoutesRouter.storage.basePath} element={<StorageRoutes />} />
        <Route path={AppRoutesRouter.Boats} element={<BoatsScreen />} />
        <Route path={AppRoutesRouter.Admin.basePath} element={<AdminRoutes />} />
        <Route
          path={AppRoutesRouter.Project.basePath}
          element={
            <FeatureRoute
              integrationKey={AppFeatureIntegration.PortalMainProjectManagement}
              accessField="hasProjectPlanningAccess"
              scope={AppFeatureScope.Global}
              element={<ProjectRoutes />}
            />
          }
        />
        <Route
          path={AppRoutesRouter.ProjectAdmin.basePath}
          element={
            <FeatureRoute
              integrationKey={AppFeatureIntegration.PortalProjectAdmin}
              scope={AppFeatureScope.Global}
              element={<ProjectAdminRoutes />}
            />
          }
        />
        <Route path={AppRoutesRouter.CertificateDatabase} element={<CertificateDatabaseContainer />} />
        <Route path="*" element={<Navigate to={AppRoutesRouter.Home} />} />
      </Routes>
    </Box>
  )
}
